import React, { useState, useEffect, useRef } from "react";
import {
  BackgroundContainer,
  SlideWrapper,
  SlideContent,
  SlideImage,
  SlideText,
  SlideHeading,
  SlideDescription,
  CarouselDots,
} from "./styles";

import Agriculture from "./assets/agriculture2.jpg";
import Academics from "./assets/academics2.jpg";
import Arts from "./assets/arts2.jpg";
import Beauty from "./assets/beauty.jpg";
import Business from "./assets/Business.jpg";
import Finance from "./assets/Finance.jpg";
import Health from "./assets/Health.jpg";
import Industries from "./assets/industries.jpg";
import LifeSkills from "./assets/lifeSkills.png";
import Medicine from "./assets/medicine.jpg";
import Technology from "./assets/Technology.jpg";
import Logo from "./assets/logo.png";

const slides = [
  {
    heading: "Academics",
    image: Academics,
  },
  {
    heading: "Agriculture",
    image: Agriculture,
  },
  {
    heading: "Arts",
    image: Arts,
  },
  {
    heading: "Beauty and Fashion",
    image: Beauty,
  },
  {
    heading: "Business",
    image: Business,
  },
  {
    heading: "Finance",
    image: Finance,
  },
  {
    heading: "Health",
    image: Health,
  
  },
  {
    heading: "Industries",
    image: Industries,
  
  },
  {
    heading: "Life skills",
    image: LifeSkills,
  
  },
  {
    heading: "Medicine",
    image: Medicine,
    
  },
  {
    heading: "Technology",
    image: Technology,
  },
];

const AUTO_ADVANCE_INTERVAL = 2000; // 3 seconds

const HeroSection = () => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, AUTO_ADVANCE_INTERVAL);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  return (
    <BackgroundContainer>
      <SlideWrapper>
        {slides.map((slide, idx) => {
          const isActive = idx === current;
          return (
            <SlideContent key={idx} active={isActive} isTextLeft={idx % 2 === 0}>
              <SlideText>
                <SlideHeading>{slide.heading}</SlideHeading>
                {slide.description && (
                  <SlideDescription>{slide.description}</SlideDescription>
                )}
              </SlideText>
              <SlideImage src={slide.image} alt={slide.heading} />
            </SlideContent>
          );
        })}
      </SlideWrapper>
      <CarouselDots>
        {slides.map((_, idx) => (
          <span
            key={idx}
            className={idx === current ? "active" : ""}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </CarouselDots>
    </BackgroundContainer>
  );
};

export default HeroSection;
